// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
    --primary: #1e40af;
    --primary-dark: #1e3a8a;
    --secondary: #64748b;
    --success: #10b981;
    --danger: #ef4444;
    --warning: #f59e0b;
    --bg: #f8fafc;
    --card: #ffffff;
    --border: #e2e8f0;
}

/* ============================================
   STICKY TOP - Zone figée
   ============================================ */
.sticky-top {
    position: sticky;
    top: 0;
    z-index: 100;
    background: var(--bg);
    padding-bottom: 8px;
}

/* Les regles \`.dashboard-row\`, \`.dashboard-left\`, \`.dashboard-right\` et
   \`.dashboard-split-divider\` ont ete RETIREES au lot 5.5, avec le curseur de
   separation qu'elles habillaient (decision D2 : il n'est pas dans la maquette).
   La zone haute est desormais \`.pl-topzone\`, dans PlanningApp.css. */


/* ============================================
   DASHBOARD CONTENT
   ============================================ */
.dashboard-content {
    background: var(--card);
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    display: flex;
    gap: 20px;
    align-items: flex-start;
    height: 100%;
}

.dashboard-compteurs {
    flex: 0 0 auto;
    min-width: 250px;
}

.dashboard-indicateurs {
    flex: 1 1;
    min-width: 200px;
}

.dashboard-title {
    font-size: 0.9rem;
    color: var(--primary);
    margin-bottom: 8px;
    font-weight: 700;
}

/* Tableau compteurs */
.dashboard-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}

.dashboard-table th {
    padding: 5px 8px;
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--secondary);
    border-bottom: 2px solid var(--border);
}

.dashboard-table th:first-child {
    text-align: left;
}

.dashboard-table td {
    padding: 4px 8px;
    text-align: center;
    border-bottom: 1px solid var(--border);
}

.dashboard-table td:first-child {
    text-align: left;
    font-weight: 600;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.dashboard-groupe-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.dashboard-col-f { color: #1e293b; }
.dashboard-col-e { color: #64748b; }
.dashboard-col-s { color: #7C3AED; }

.dashboard-val-f { color: #1e293b; font-weight: 600; }
.dashboard-val-e { color: #64748b; font-weight: 600; }
.dashboard-val-s { color: #7C3AED; font-weight: 600; }

.dashboard-total-row {
    background: var(--bg);
}

.dashboard-total-row td {
    border-top: 2px solid var(--primary);
    border-bottom: none;
    padding: 6px 8px;
}

.dashboard-no-data {
    text-align: center;
    padding: 15px;
    color: var(--secondary);
    font-size: 13px;
    background: var(--bg);
    border-radius: 8px;
}

/* Placeholder indicateurs */
.dashboard-placeholder {
    background: var(--bg);
    border: 2px dashed var(--border);
    border-radius: 10px;
    padding: 15px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.dashboard-placeholder-icon {
    font-size: 1.8rem;
    flex-shrink: 0;
}

.dashboard-placeholder-text {
    font-size: 12px;
    color: var(--secondary);
}

.dashboard-placeholder-text p {
    margin-bottom: 4px;
}

.dashboard-placeholder-text ul {
    margin: 0;
    padding-left: 18px;
}

.dashboard-placeholder-text li {
    margin-bottom: 2px;
    font-size: 11px;
}

/* ============================================
   FILTRES - Colonnes par niveau
   ============================================ */
.filter-panel {
    background: var(--card);
    border-radius: 12px;
    padding: 10px 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    height: 100%;
}

.filter-niveaux-grid {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.filter-niveau-column {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 100px;
}

.filter-niveau-btn {
    font-weight: 700 !important;
    font-size: 12px !important;
    width: 100%;
    justify-content: center;
    margin-bottom: 3px;
}

.filter-groupes-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-left: 8px;
    border-left: 3px solid var(--border);
}

.filter-groupe-btn {
    font-size: 10px !important;
    padding: 3px 8px !important;
    width: 100%;
    justify-content: flex-start;
}

/* ============================================
   CALENDAR STATUS BAR (compact)
   ============================================ */
.calendar-status-bar {
    background: var(--card);
    padding: 5px 15px;
    border-radius: 8px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    font-size: 12px;
}

.calendar-edit-hints {
    display: flex;
    gap: 12px;
    color: #475569;
    flex-wrap: wrap;
}

.calendar-edit-hints span {
    font-size: 11px;
}

* { margin: 0; padding: 0; box-sizing: border-box; }

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: var(--bg);
    color: #1e293b;
}

/* ============================================
   FILTRES - Colonnes par niveau
   ============================================ */
.filter-panel {
    background: var(--card);
    border-radius: 12px;
    padding: 12px 20px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.filter-niveaux-grid {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.filter-niveau-column {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 120px;
}

.filter-niveau-btn {
    font-weight: 700 !important;
    font-size: 13px !important;
    width: 100%;
    justify-content: center;
    margin-bottom: 4px;
}

.filter-groupes-list {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding-left: 8px;
    border-left: 3px solid var(--border);
}

.filter-groupe-btn {
    font-size: 11px !important;
    padding: 4px 10px !important;
    width: 100%;
    justify-content: flex-start;
}

.container { max-width: 1920px; margin: 0 auto; padding: 20px; }
.container-fluid { margin: 0 20px; padding: 20px 0; }

.header {
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: white; padding: 30px; border-radius: 12px;
    margin-bottom: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
}
.header h1 { font-size: 1.8rem; margin-bottom: 8px; }

.toolbar {
    background: var(--card); padding: 15px 20px; border-radius: 12px;
    margin-bottom: 15px; display: flex; gap: 15px;
    flex-wrap: wrap; align-items: center; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.btn {
    padding: 10px 20px; border: none; border-radius: 8px;
    font-weight: 600; cursor: pointer; transition: all 0.2s;
    font-size: 14px; display: inline-flex; align-items: center; gap: 8px;
}
.btn:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
.btn-primary { background: var(--primary); color: white; }
.btn-success { background: var(--success); color: white; }
.btn-warning { background: var(--warning); color: white; }
.btn-danger { background: var(--danger); color: white; }
.btn-secondary { background: var(--secondary); color: white; }
.btn-small { padding: 6px 14px; font-size: 13px; }
.btn-large { font-size: 16px; }

.input-group { display: flex; align-items: center; gap: 10px; }
input, select { padding: 10px 15px; border: 2px solid var(--border); border-radius: 8px; font-size: 14px; }
input:focus, select:focus { outline: none; border-color: var(--primary); }

/* Calendar wrapper - pleine largeur avec scroll auto */
.calendar-wrapper {
    background: var(--card); border-radius: 12px; padding: 15px;
    overflow-x: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    position: relative; cursor: default;
}
.calendar-grid { display: flex; gap: 2px; min-width: max-content; }

.month-column {
    flex: 1 1; min-width: 120px;
    border: 1px solid var(--border); border-radius: 6px;
    overflow: hidden; background: white;
}
.month-header {
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: white; padding: 8px; text-align: center; font-weight: 700; font-size: 12px;
}

.days-grid { display: grid; }
.column-headers { display: grid; }

.day-cell {
    border: 1px solid #f0f0f0; padding: 3px 2px; min-height: 26px;
    display: flex; align-items: center; justify-content: center;
    font-size: 10px; transition: all 0.1s;
}
.day-letter { font-weight: 700; color: #64748b; font-size: 9px; }
.day-number { font-weight: 600; font-size: 10px; }

.interactive-cell { cursor: pointer; font-weight: 700; font-size: 11px; user-select: none; }
.interactive-cell:hover:not(.weekend):not(.holiday) { box-shadow: inset 0 0 0 2px var(--primary); background: #f0f7ff; }

.weekend { background: repeating-linear-gradient(45deg, #f1f5f9, #f1f5f9 4px, #e2e8f0 4px, #e2e8f0 8px) !important; cursor: default !important; }
.holiday { background: #fee2e2 !important; color: #991b1b !important; font-weight: 700; cursor: default !important; }
.vacation { background: #dbeafe !important; color: #1e40af !important; }
.formation { background: #1e293b !important; color: white !important; font-weight: 700; }
.entreprise { background: #94a3b8 !important; color: white !important; font-weight: 700; }

.col-header { padding: 4px 2px; text-align: center; font-size: 9px; font-weight: 700; color: var(--secondary); background: var(--bg); border: 1px solid var(--border); }
.col-header-groupe { font-size: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.column-headers { border-bottom: 2px solid var(--primary); }

/* Instructions bar */
.instructions-bar {
    background: white; padding: 10px 20px; border-radius: 12px;
    margin-bottom: 10px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    display: flex; flex-wrap: wrap; gap: 15px; align-items: center;
}
.instruction-item { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #475569; }
.instruction-stats { display: flex; gap: 8px; margin-left: auto; }
.stat-badge { padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; }
.formation-badge { background: #1e293b; color: white; }
.entreprise-badge { background: #94a3b8; color: white; }
.saving-indicator { color: var(--warning); font-weight: 600; }

/* Edit toggle */
.edit-toggle { font-size: 13px; padding: 8px 16px; }
.edit-active { animation: pulse-green 2s infinite; }
@keyframes pulse-green { 0%, 100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4); } 50% { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0); } }

/* Filter bar */
.filter-bar {
    background: white; padding: 10px 20px; border-radius: 12px;
    margin-bottom: 10px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    display: flex; flex-wrap: wrap; gap: 10px; align-items: center;
}
.filter-label { font-weight: 700; color: var(--primary); font-size: 13px; }
.filter-group { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.filter-btn { padding: 5px 10px; border: 2px solid var(--border); border-radius: 20px; background: white; cursor: pointer; font-size: 11px; font-weight: 600; transition: all 0.2s; white-space: nowrap; }
.filter-active { background: #f0f7ff; border-color: var(--primary); color: var(--primary); }
.filter-hidden { background: #f8f9fa; color: #adb5bd; border-color: #dee2e6; opacity: 0.7; }
.filter-niveau { font-weight: 700; font-size: 12px; }
.filter-btn:hover { transform: translateY(-1px); }

/* Modal */
.modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-content { background: white; padding: 30px; border-radius: 16px; max-width: 500px; width: 90%; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
.modal-header { margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px solid var(--border); }

.form-group { margin-bottom: 15px; }
.form-group label { display: block; margin-bottom: 8px; font-weight: 600; color: #475569; }
.form-group input, .form-group select { width: 100%; }

.login-container { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%); }
.login-card { background: white; padding: 48px 52px; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); max-width: 640px; width: 90%; }
.login-card h1 { margin-bottom: 30px; color: var(--primary); white-space: nowrap; font-size: 1.6rem; }

.alert { padding: 12px 16px; border-radius: 8px; margin-bottom: 15px; font-weight: 500; }
.alert-success { background: #d1fae5; color: #065f46; border: 1px solid #10b981; }
.alert-error { background: #fee2e2; color: #991b1b; border: 1px solid #ef4444; }

.legend { background: white; padding: 15px; border-radius: 12px; margin-top: 15px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.legend h3 { margin-bottom: 10px; font-size: 1rem; }
.legend-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 8px; }
.legend-item { display: flex; align-items: center; gap: 8px; font-size: 13px; }
.legend-color { width: 25px; height: 16px; border-radius: 3px; border: 1px solid var(--border); }

.loading { text-align: center; padding: 40px; }
.spinner { border: 4px solid #f3f3f3; border-top: 4px solid var(--primary); border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

.stats-card { background: white; padding: 15px; border-radius: 12px; margin-top: 15px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 10px; }
.stat-item { padding: 12px; background: var(--bg); border-radius: 8px; border-left: 4px solid var(--primary); }
.stat-label { font-size: 11px; color: var(--secondary); margin-bottom: 4px; text-transform: uppercase; font-weight: 600; }
.stat-value { font-size: 20px; font-weight: 700; color: var(--primary); }
.setup-row .form-group { flex: 1 1; min-width: 200px; }
.niveau-header { padding: 12px 16px; background: var(--bg); display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; }
.checkbox-label { display: flex; align-items: center; gap: 10px; cursor: pointer; }
.checkbox-label input[type="checkbox"] { width: 18px; height: 18px; cursor: pointer; }
.niveau-title { font-weight: 700; font-size: 1.1rem; color: var(--primary); }
.niveau-subtitle { color: var(--secondary); font-size: 0.85rem; }
.btn-icon { width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 700; transition: all 0.2s; }
.btn-icon:disabled { opacity: 0.3; cursor: not-allowed; }
.groupes-info { font-size: 13px; color: var(--secondary); margin-bottom: 12px; }
.single-group { color: var(--success); }
.groupes-list { display: flex; flex-direction: column; gap: 8px; }
.groupe-item { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: var(--bg); border-radius: 8px; border: 1px solid var(--border); }
.groupe-numero { font-weight: 700; color: var(--secondary); font-size: 13px; min-width: 22px; }
.groupe-input { flex: 1 1; min-width: 120px; }
.groupe-preview { font-size: 12px; color: var(--primary); font-weight: 600; min-width: 100px; }

.resume-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 8px; margin-bottom: 15px; }
.resume-item { padding: 10px 12px; background: var(--bg); border-radius: 8px; font-size: 13px; }
.resume-item strong { color: var(--primary); }
.colonnes-preview { margin: 15px 0; }
.colonnes-preview h3 { font-size: 0.95rem; margin-bottom: 8px; color: #475569; }
.colonnes-preview-grid { display: flex; gap: 2px; overflow-x: auto; }
.colonne-preview-header { padding: 8px 6px; background: var(--primary); color: white; font-weight: 700; font-size: 11px; text-align: center; min-width: 70px; border-radius: 4px 4px 0 0; white-space: nowrap; }
.setup-buttons { display: flex; gap: 12px; margin-top: 15px; flex-wrap: wrap; }














































/* ============================================
   ÉVÉNEMENTS - PASTILLES SUR LE CALENDRIER
   ============================================ */
.day-number {
    position: relative;
    flex-direction: column;
    gap: 1px;
}

.day-number-text {
    line-height: 1;
}

.has-events {
    padding-bottom: 2px;
}

.event-pastilles {
    display: flex;
    gap: 2px;
    justify-content: center;
    flex-wrap: wrap;
}

.event-pastille {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 0.2s;
    border: 1px solid rgba(255,255,255,0.5);
    flex-shrink: 0;
}

.event-pastille:hover {
    transform: scale(1.5);
}

/* PA.0 (2026-10-28) : le calendrier tient dans la hauteur de la fenêtre — Calendar.js calcule --pl-ligne (16 à 26 px).
   Hauteur MINIMALE seulement : une date chargée d'événements agrandit encore sa ligne, rien n'est masqué. */
.calendar-wrapper .days-grid .day-cell { min-height: var(--pl-ligne, 26px); }
.calendar-wrapper.cal-ajuste .days-grid .day-cell { padding-top: 0; padding-bottom: 0; }
.calendar-wrapper.cal-ajuste .has-events { padding-bottom: 0; }
.calendar-wrapper.cal-ajuste .event-pastille { width: 6px; height: 6px; }

/* ============================================
   ÉVÉNEMENTS - TOOLTIP
   ============================================ */
.event-tooltip {
    position: fixed;
    z-index: 9999;
    background: #1e293b;
    color: white;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    pointer-events: none;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    gap: 6px;
}

.event-tooltip-icon {
    font-size: 14px;
}

/* ============================================
   ÉVÉNEMENTS - CONTEXT MENU
   ============================================ */
.event-context-menu {
    position: fixed;
    z-index: 10000;
    background: white;
    border: 1px solid var(--border);
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
    overflow: hidden;
    min-width: 160px;
}

.context-menu-item {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: background 0.15s;
    display: flex;
    align-items: center;
    gap: 8px;
}

.context-menu-item:hover {
    background: var(--bg);
}

.context-menu-danger {
    color: var(--danger);
}

.context-menu-danger:hover {
    background: #fee2e2;
}






































@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-2px); }
    to { opacity: 1; transform: translateY(0); }
}





/* ============================================
   HEADER - NOM DÉPARTEMENT
   ============================================ */
.header-dept-name {
    font-size: 1.4rem;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.9);
    margin: 4px 0 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
}
/* ============================================
   STAGE - CELLULE
   ============================================ */
.stage {
    background: #7C3AED !important;
    color: white !important;
    font-weight: 700;
}

.stage-badge {
    background: #7C3AED;
    color: white;
}

/* ============================================
   DATE CLICKABLE
   ============================================ */
.date-clickable {
    cursor: pointer;
    transition: all 0.15s;
}

.date-clickable:hover {
    background: #dbeafe !important;
    box-shadow: inset 0 0 0 2px var(--primary);
}

/* ============================================
   DATE EVENT PICKER - POPUP
   ============================================ */
.date-event-picker {
    position: fixed;
    z-index: 950;
    width: 310px;
    max-height: 400px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: pickerAppear 0.15s ease-out;
}

@keyframes pickerAppear {
    from { opacity: 0; transform: scale(0.95) translateY(-5px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}

.dep-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background: var(--primary);
    color: white;
}

.dep-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
}

.dep-hint {
    padding: 8px 14px;
    background: #FEF3C7;
    color: #92400E;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
    animation: hintPulse 2s infinite;
}

@keyframes hintPulse {
    0%, 100% { background: #FEF3C7; }
    50% { background: #FDE68A; }
}

.dep-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 8px;
}

.dep-section {
    margin-bottom: 8px;
}

.dep-section-title {
    font-size: 11px;
    font-weight: 700;
    color: var(--secondary);
    padding: 4px 6px;
    text-transform: uppercase;
}

.dep-event-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border: 1px solid var(--border);
    border-left: 4px solid var(--primary);
    border-radius: 6px;
    margin-bottom: 4px;
    cursor: pointer;
    transition: all 0.15s;
    font-size: 12px;
}

.dep-event-item:hover {
    background: #EFF6FF;
    border-color: var(--primary);
    transform: translateX(3px);
}

.dep-event-placed {
    background: #F9FAFB;
    opacity: 0.8;
}

.dep-event-placed:hover {
    opacity: 1;
    background: #FEF3C7;
}

.dep-event-icon {
    font-size: 1rem;
    flex-shrink: 0;
}

.dep-event-label {
    flex: 1 1;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dep-event-old-date {
    font-size: 10px;
    color: var(--secondary);
    background: var(--bg);
    padding: 2px 6px;
    border-radius: 8px;
    white-space: nowrap;
    flex-shrink: 0;
}

.dep-event-delete {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 12px;
    padding: 2px;
    opacity: 0.4;
    transition: opacity 0.2s;
    flex-shrink: 0;
}

.dep-event-delete:hover {
    opacity: 1;
}

.dep-empty {
    text-align: center;
    padding: 15px;
    color: var(--secondary);
    font-size: 12px;
}

.dep-create-btn {
    width: 100%;
    padding: 8px;
    border: 2px dashed var(--border);
    border-radius: 6px;
    background: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: var(--secondary);
    transition: all 0.2s;
    margin-top: 4px;
}

.dep-create-btn:hover {
    border-color: var(--primary);
    color: var(--primary);
    background: #EFF6FF;
}

.dep-create-form {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-top: 4px;
    flex-wrap: wrap;
}

.dep-create-select {
    padding: 5px;
    border: 1px solid var(--border);
    border-radius: 4px;
    font-size: 11px;
    min-width: 100px;
}

.dep-create-input {
    flex: 1 1;
    padding: 5px 8px;
    border: 2px solid var(--primary);
    border-radius: 4px;
    font-size: 12px;
    min-width: 80px;
}

/* ============================================
   ADMIN PANEL
   ============================================ */
.admin-section {
    margin-top: 15px;
}

.admin-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.admin-section-header h2 {
    font-size: 1.3rem;
    color: var(--primary);
}

/* Form card */
.admin-form-card {
    background: white;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    border: 2px solid var(--primary);
}

.admin-form-card h3 {
    font-size: 1rem;
    color: var(--primary);
    margin-bottom: 15px;
}

.admin-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 15px;
}

.admin-form-actions {
    display: flex;
    gap: 8px;
    margin-top: 15px;
}

/* Dept selector */
.admin-depts-selector {
    margin-top: 12px;
}

.admin-depts-selector > label {
    display: block;
    font-weight: 600;
    color: #475569;
    margin-bottom: 8px;
    font-size: 13px;
}

.admin-depts-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.admin-dept-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 2px solid var(--border);
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s;
    user-select: none;
}

.admin-dept-chip:hover {
    border-color: var(--primary);
}

.admin-dept-chip input[type="checkbox"] {
    width: 14px;
    height: 14px;
    cursor: pointer;
}

.admin-dept-selected {
    background: #dbeafe;
    border-color: var(--primary);
    color: var(--primary);
}

/* Table */
.admin-table {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.admin-table table {
    width: 100%;
    border-collapse: collapse;
}

.admin-table th {
    background: var(--bg);
    padding: 12px 15px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: var(--secondary);
    text-transform: uppercase;
    border-bottom: 2px solid var(--border);
}

.admin-table td {
    padding: 10px 15px;
    border-bottom: 1px solid var(--border);
    font-size: 13px;
}

.admin-table tr:hover {
    background: #f8fafc;
}

.admin-row-inactive {
    opacity: 0.5;
}

.admin-cell-email {
    font-weight: 600;
    color: var(--primary);
}

/* Role badges */
.admin-role-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
}

.admin-role-admin {
    background: #FEE2E2;
    color: #991B1B;
}

.admin-role-gestionnaire {
    background: #DBEAFE;
    color: #1E40AF;
}

.admin-role-lecture {
    background: #F3F4F6;
    color: #6B7280;
}

/* Status */
.admin-status {
    font-size: 12px;
    font-weight: 600;
}

.admin-status-active {
    color: var(--success);
}

.admin-status-inactive {
    color: var(--danger);
}

/* Dept tags */
.admin-dept-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.admin-dept-tag {
    padding: 2px 8px;
    background: var(--bg);
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    color: var(--primary);
    border: 1px solid var(--border);
}

.admin-dept-all {
    background: #FEF3C7;
    color: #92400E;
    border-color: #F59E0B;
}

/* Actions */
.admin-actions {
    display: flex;
    gap: 4px;
}

/* Dept select in toolbar */
.admin-dept-select {
    padding: 8px 12px;
    border: 2px solid var(--border);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    min-width: 200px;
}

/* Dept cards */
.admin-dept-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
}

.admin-dept-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border: 2px solid var(--border);
    transition: all 0.2s;
}

.admin-dept-card:hover {
    border-color: var(--primary);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.admin-dept-card-inactive {
    opacity: 0.5;
}

.admin-dept-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
}

.admin-dept-card-code {
    font-size: 11px;
    font-weight: 700;
    color: var(--secondary);
    text-transform: uppercase;
    letter-spacing: 1px;
}

.admin-dept-card-name {
    font-size: 1.1rem;
    color: var(--primary);
    margin-top: 2px;
}

.admin-dept-card-desc {
    font-size: 12px;
    color: var(--secondary);
    margin-bottom: 10px;
}

.admin-dept-card-stats {
    display: flex;
    gap: 15px;
    font-size: 12px;
    color: var(--secondary);
    margin-bottom: 12px;
    padding: 8px 0;
    border-top: 1px solid var(--border);
    border-bottom: 1px solid var(--border);
}

.admin-dept-card-actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}











/* ============================================
   CALENDAR STATUS BAR (compact)
   ============================================ */
.calendar-status-bar {
    background: var(--card);
    padding: 6px 15px;
    border-radius: 8px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    font-size: 12px;
}

.calendar-edit-hints {
    display: flex;
    gap: 12px;
    color: #475569;
    flex-wrap: wrap;
}

.calendar-edit-hints span {
    font-size: 12px;
}

.calendar-status-stats {
    display: flex;
    gap: 6px;
    margin-left: auto;
}

/* ============================================
   FOOTER
   ============================================ */
.app-footer {
    background: linear-gradient(135deg, var(--primary-dark) 0%, #0f172a 100%);
    color: rgba(255, 255, 255, 0.8);
    padding: 15px 20px;
    margin-top: 30px;
    border-radius: 12px 12px 0 0;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    max-width: 1920px;
    margin: 0 auto;
}

.footer-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.footer-copyright {
    font-size: 12px;
    font-weight: 600;
}

.footer-version {
    font-size: 10px;
    background: rgba(255, 255, 255, 0.15);
    padding: 2px 8px;
    border-radius: 8px;
    font-weight: 600;
}

.footer-links {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.footer-link {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    transition: all 0.2s;
    font-weight: 500;
    text-decoration: none;
}

.footer-link:hover {
    color: white;
    background: rgba(255, 255, 255, 0.1);
    text-decoration: underline;
}

.footer-dot {
    color: rgba(255, 255, 255, 0.3);
    font-size: 10px;
}

.footer-right {
    font-size: 12px;
}

.footer-email {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-weight: 600;
}

.footer-email:hover {
    text-decoration: underline;
    color: white;
}

.footer-contact {
    font-size: 12px;
}

/* ============================================
   MODALES LÉGALES
   ============================================ */
.legal-modal {
    background: white;
    border-radius: 16px;
    max-width: 800px;
    width: 95%;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    overflow: hidden;
}

.legal-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: white;
}

.legal-modal-header h2 {
    font-size: 1.3rem;
    margin: 0;
}

.legal-modal-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.legal-modal-close:hover {
    background: rgba(255, 255, 255, 0.4);
}

.legal-modal-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 25px;
}

.legal-modal-footer {
    padding: 15px 25px;
    border-top: 1px solid var(--border);
    display: flex;
    justify-content: flex-end;
}

/* ============================================
   CONTENU LÉGAL
   ============================================ */
.legal-content section {
    margin-bottom: 25px;
}

.legal-content section:last-child {
    margin-bottom: 0;
}

.legal-content h3 {
    font-size: 1rem;
    color: var(--primary);
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 2px solid var(--border);
}

.legal-content p {
    font-size: 14px;
    line-height: 1.7;
    color: #334155;
    margin-bottom: 10px;
}

.legal-content ul {
    margin: 8px 0;
    padding-left: 24px;
}

.legal-content li {
    font-size: 14px;
    line-height: 1.7;
    color: #334155;
    margin-bottom: 4px;
}

.legal-content a {
    color: var(--primary);
    text-decoration: none;
    font-weight: 600;
}

.legal-content a:hover {
    text-decoration: underline;
}

.legal-content code {
    background: var(--bg);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 13px;
    color: var(--primary);
    font-weight: 600;
}

.legal-content strong {
    color: #1e293b;
}

/* Tableaux légaux */
.legal-table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    font-size: 13px;
}

.legal-table th {
    background: var(--bg);
    padding: 10px 12px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: var(--primary);
    border-bottom: 2px solid var(--border);
}

.legal-table td {
    padding: 8px 12px;
    border-bottom: 1px solid var(--border);
    color: #334155;
    line-height: 1.5;
}

.legal-table tr:hover {
    background: #f8fafc;
}

/* ============================================
   FOOTER RESPONSIVE
   ============================================ */
@media (max-width: 768px) {
    .footer-content {
        flex-direction: column;
        text-align: center;
    }

    .footer-links {
        justify-content: center;
    }

    .legal-modal {
        width: 100%;
        max-height: 95vh;
        border-radius: 12px 12px 0 0;
    }

    .legal-modal-body {
        padding: 15px;
    }

    .legal-table {
        font-size: 11px;
    }

    .legal-table th,
    .legal-table td {
        padding: 6px 8px;
    }
}

/* ============================================
   LOGIN PAGE - Layout avec footer
   ============================================ */
.login-page {
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
}

.login-page .login-container {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-page .app-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin-top: 0;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 10;
}

.type-journee-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: var(--bg);
    border-radius: 8px;
    border: 1px solid var(--border);
}

.type-journee-code-wrapper {
    flex: 0 0 auto;
}

.type-journee-code {
    width: 40px !important;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
    padding: 6px !important;
}

.type-journee-libelle {
    flex: 1 1;
    min-width: 120px;
}

.type-journee-preview {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    flex-shrink: 0;
    border: 1px solid rgba(0,0,0,0.1);
}

/* ============================================
   TYPES PREVIEW (résumé)
   ============================================ */
.types-preview {
    margin-top: 12px;
}

.types-preview h3 {
    font-size: 0.95rem;
    margin-bottom: 8px;
    color: #475569;
}

.types-preview-grid {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.type-preview-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
}

.type-preview-badge {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
    flex-shrink: 0;
	margin-bottom: 12px;
}

/* ============================================
   TYPE JOURNÉE - CELLULE DYNAMIQUE
   ============================================ */
.type-journee-cell {
    font-weight: 700;
}

.niveau-actions .btn-icon {
    width: 28px;
    height: 28px;
    font-size: 12px;
    background: var(--bg);
    color: var(--secondary);
    border: 1px solid var(--border);
}

.niveau-actions .btn-icon:hover:not(:disabled) {
    background: var(--primary);
    color: white;
    border-color: var(--primary);
}

.niveau-actions .btn-moins {
    background: #fee2e2;
    color: var(--danger);
    border-color: #fecaca;
}

.niveau-actions .btn-moins:hover:not(:disabled) {
    background: var(--danger);
    color: white;
}

/* ============================================
   TYPE MÉMORISÉ - INDICATEUR FIXE À GAUCHE
   ============================================ */
.memorized-type-indicator {
    min-width: 170px;
    max-width: 170px;
    padding: 3px 12px;
    border-radius: 12px;
    font-size: 11px;
    white-space: nowrap;
    text-align: center;
    border: 1px solid;
    flex-shrink: 0;
}

/* ============================================
   CALENDAR STATUS BAR
   ============================================ */
.calendar-status-bar {
    background: var(--card);
    padding: 5px 15px;
    border-radius: 8px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: nowrap;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    font-size: 12px;
}

.calendar-edit-hints {
    display: flex;
    gap: 12px;
    color: #475569;
    flex-wrap: wrap;
}

.calendar-edit-hints span {
    font-size: 11px;
}

/* ============================================
   SCROLL HORIZONTAL CALENDRIER
   ============================================ */
.calendar-wrapper {
    overflow-x: auto;
    overflow-y: visible;
}

/* ============================================
   LÉGENDE - RACCOURCI CLAVIER
   ============================================ */
.legend-shortcut {
    color: var(--secondary);
    font-style: italic;
    font-size: 12px;
}

.legend h3 {
    display: none;
}

/* \`.dashboard-section\` et \`.dashboard-collapse-btn\` RETIREES au lot 5.5 : un
   seul bouton repliait les DEUX volets a la fois. Ce sont maintenant deux cartes
   repliables independamment, dont le titre porte le chevron (\`.pl-repliable\`). */

.type-row-disabled {
    opacity: 0.6;
    background: #f8fafc;
}

/* --- Types légende --- */
.types-legend {
    margin-top: 12px;
    padding: 8px 14px;
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 8px;
    font-size: 0.78rem;
    color: #0c4a6e;
    line-height: 1.5;
}

.types-legend p {
    margin: 2px 0;
}

/* =============================================================================
   Niveaux 2 — Affichage condensé en ligne
   ============================================================================= */

/* --- En-tête du tableau groupes --- */
.groupes-table-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    background: #f1f5f9;
    border-radius: 6px;
    margin-bottom: 4px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.gt-h-num { width: 28px; text-align: center; }
.gt-h-couleur { width: 30px; }
.gt-h-nom { width: 110px; }
.gt-h-heures-label { flex: 0 0 auto; margin-left: auto; margin-right: 4px; font-style: italic; }

.gt-h-type {
    width: 80px;
    text-align: center;
    font-weight: 700;
    font-size: 0.8rem;
}

.gt-h-type-disabled {
    text-decoration: line-through;
    opacity: 0.5;
}

.gt-num {
    width: 28px;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 600;
    color: #94a3b8;
}

.gt-couleur { width: 30px; }

.gt-nom {
    width: 110px;
    padding: 4px 6px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 0.85rem;
}

.gt-nom-single {
    border: none;
    font-weight: 600;
    color: #334155;
    background: transparent;
    padding: 4px 6px;
}

.gt-heures-sep {
    flex: 0 0 auto;
    margin-left: auto;
}

/* --- Cellule heures par type --- */
.gt-heures-cell {
    display: flex;
    align-items: center;
    gap: 3px;
    width: 80px;
    justify-content: center;
}

.gt-heures-disabled {
    opacity: 0.4;
}

.gt-type-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 3px;
    font-size: 0.7rem;
    font-weight: 700;
    flex-shrink: 0;
}

.gt-heures-input {
    width: 54px;
    padding: 3px 4px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    text-align: right;
    font-size: 0.85rem;
    font-weight: 600;
    font-family: 'Courier New', monospace;
}

.gt-heures-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.gt-heures-unit {
    font-size: 0.75rem;
    color: #64748b;
}

.gt-heures-grise {
    font-size: 0.75rem;
    color: #cbd5e1;
    font-style: italic;
    letter-spacing: 1px;
}

/* --- Résumé : info contrôle --- */
.type-preview-info {
    font-size: 0.72rem;
    color: #64748b;
    font-style: italic;
    margin-left: 2px;
}

/* =============================================================================
   DASHBOARD — Couverture heures
   ============================================================================= */

.couverture-sections {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.couverture-section {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 12px;
}

.couverture-section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e2e8f0;
}

.couverture-type-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 700;
    flex-shrink: 0;
}

.couverture-type-label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #334155;
}

.couverture-no-data {
    font-size: 0.78rem;
    color: #94a3b8;
    font-style: italic;
    padding: 4px 0;
}

.couverture-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.couverture-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.couverture-item-none {
    flex-direction: row;
    align-items: center;
    gap: 6px;
    opacity: 0.5;
}

.couverture-item-top {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.78rem;
}

.couverture-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.couverture-label {
    font-weight: 600;
    color: #334155;
    font-size: 0.78rem;
    min-width: 70px;
}

.couverture-heures {
    color: #64748b;
    font-size: 0.72rem;
    margin-left: auto;
    white-space: nowrap;
}

.couverture-na {
    font-size: 0.72rem;
    color: #94a3b8;
    font-style: italic;
}

.couverture-bar-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 14px;
}

.couverture-bar-bg {
    flex: 1 1;
    height: 10px;
    background: #e2e8f0;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    min-width: 80px;
}

.couverture-bar-fill {
    height: 100%;
    border-radius: 5px;
    transition: width 0.4s ease;
}

.couverture-bar-over {
    position: absolute;
    top: 0;
    height: 100%;
    border-radius: 0 5px 5px 0;
}

.couverture-pct {
    font-size: 0.78rem;
    font-weight: 700;
    min-width: 38px;
    text-align: right;
}

.couverture-icone {
    font-size: 0.75rem;
    flex-shrink: 0;
}

/* =============================================================================
   DASHBOARD — Indicateurs tableau
   ============================================================================= */

.indicateurs-table th {
    font-size: 0.7rem !important;
    padding: 4px 6px !important;
    white-space: nowrap;
}

.indicateurs-table td {
    padding: 4px 6px !important;
    font-size: 0.78rem;
}

.indicateurs-table td:first-child {
    display: table-cell !important;
    text-align: center !important;
}

.indicateur-type-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    font-size: 0.68rem;
    font-weight: 700;
}

.indicateur-val {
    text-align: right !important;
    font-family: 'Courier New', monospace;
    font-weight: 600;
    white-space: nowrap;
}

.indicateur-icone {
    text-align: center !important;
    font-size: 0.75rem;
}

.indicateur-pct {
    text-align: right !important;
    font-weight: 700;
    font-size: 0.82rem !important;
    white-space: nowrap;
}

/* =============================================================================
   MATRICE VISIBILITÉ PAR MOIS — dans filter-panel
   ============================================================================= */

.mois-detail-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    padding: 6px 12px;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 700;
    color: var(--primary);
    transition: all 0.2s;
    width: 100%;
    text-align: left;
}

.mois-detail-toggle:hover {
    background: #dbeafe;
    border-color: var(--primary);
}

.mois-matrix-section {
    margin-top: 8px;
    animation: fadeIn 0.2s ease;
}

.mois-matrix-wrapper {
    overflow-x: auto;
    border: 1px solid var(--border);
    border-radius: 6px;
}

.mois-matrix {
    border-collapse: collapse;
    font-size: 10px;
    width: 100%;
}

.mois-matrix th,
.mois-matrix td {
    padding: 0;
    text-align: center;
    border: 1px solid var(--border);
}

.mois-matrix-corner {
    background: var(--bg);
    min-width: 70px;
    width: 70px;
}

.mois-matrix-mois-header {
    background: var(--primary);
    color: white;
    font-weight: 700;
    font-size: 9px;
    padding: 4px 2px !important;
    min-width: 32px;
    letter-spacing: 0.5px;
}

.mois-matrix-label {
    text-align: left !important;
    background: var(--bg);
    padding: 3px 6px !important;
    font-weight: 600;
    white-space: nowrap;
}

.mois-matrix-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: middle;
}

.mois-matrix-label-text {
    font-size: 9px;
    vertical-align: middle;
    color: #334155;
}

/* Cellules cliquables */
.mois-matrix-cell {
    cursor: pointer;
    width: 32px;
    height: 24px;
    transition: all 0.15s;
    user-select: none;
    font-size: 10px;
    font-weight: 700;
}

.mois-cell-visible {
    color: white;
    text-shadow: 0 1px 1px rgba(0,0,0,0.3);
}

.mois-cell-visible:hover {
    opacity: 0.7;
}

.mois-cell-hidden {
    background: repeating-linear-gradient(
        45deg,
        #f1f5f9,
        #f1f5f9 3px,
        #e2e8f0 3px,
        #e2e8f0 6px
    ) !important;
    color: transparent;
}

.mois-cell-hidden:hover {
    background: #dbeafe !important;
    color: var(--primary) !important;
}

.mois-matrix-actions {
    display: flex;
    gap: 6px;
    margin-top: 6px;
    justify-content: flex-end;
}

.btn-students.btn-disabled,
.btn-students:disabled {
    background: #e2e8f0;
    color: #94a3b8;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.groupes-semestres-header {
    display: grid;
    grid-template-columns: 40px 40px 1fr 60px 70px 70px 60px 70px 70px 80px;
    gap: 4px;
    padding: 10px 12px;
    background: #f1f5f9;
    border-bottom: 2px solid #e5e7eb;
    font-weight: 600;
    font-size: 0.85rem;
    color: #475569;
    align-items: center;
}

/* Responsive */
@media (max-width: 900px) {
    .groupes-semestres-header,
    .groupe-row-semestres {
        grid-template-columns: 30px 30px 80px 8px 55px 55px 8px 55px 55px 60px;
        font-size: 0.75rem;
    }
    
    .gs-heures-input {
        width: 50px;
        padding: 4px;
    }
}

/* ============================================
   SETUP WIZARD - BARRE DE PROGRESSION
   ============================================ */
.progress-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.progress-modal {
    background: white;
    border-radius: 12px;
    padding: 30px 40px;
    min-width: 350px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    text-align: center;
}

.progress-title {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 20px;
}

.progress-bar-container {
    background: #e2e8f0;
    border-radius: 10px;
    height: 20px;
    overflow: hidden;
    margin-bottom: 15px;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6 0%, #22c55e 100%);
    border-radius: 10px;
    transition: width 0.3s ease;
}

.progress-message {
    font-size: 14px;
    color: #64748b;
    margin-bottom: 8px;
}

.progress-percent {
    font-size: 24px;
    font-weight: 700;
    color: #3b82f6;
}

.btn-students:hover:not(:disabled):not(.btn-disabled) {
    background: #dbeafe;
    border-color: #3b82f6;
    color: #1e40af;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
}

.btn-students.btn-disabled,
.btn-students:disabled {
    background: #f8fafc;
    color: #cbd5e1;
    border-color: #e2e8f0;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* PlanningApp - sticky-top */
.sticky-top {
    position: sticky;
    top: 8px;
    z-index: 1000;
    margin: 8px 12px 0 12px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background: white;
}

/* PlanningApp - sticky-top */
.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1000;
    margin: 0;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background: white;
}

/* Container principal */
.calendar-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    width: 100%;
}

/* Grille des mois - flexbox qui ne wrap pas */
.calendar-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 8px;
    width: max-content; /* Important : permet à la grille de dépasser */
}

/* Chaque colonne de mois - largeur automatique */
.month-column {
    flex-shrink: 0;        /* Ne pas rétrécir */
    flex-grow: 0;          /* Ne pas grandir */
    width: auto;           /* Largeur automatique basée sur le contenu */
    min-width: min-content; /* Au minimum la largeur du contenu */
}

/* Headers des colonnes */
.column-headers {
    display: grid;
    /* gridTemplateColumns est défini en inline */
    gap: 1px;
}

/* Grille des jours */
.days-grid {
    display: grid;
    /* gridTemplateColumns est défini en inline */
    gap: 1px;
}

/* Header du mois - s'adapte à la largeur */
.month-header {
	background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: white; padding: 8px; text-align: center; font-weight: 700; font-size: 12px;
    text-align: center;
    font-weight: bold;
    padding: 8px 4px;
    border-radius: 4px 4px 0 0;
    white-space: nowrap;
}

/* Cellules */
.day-cell {
    min-width: 0; /* Permet le rétrécissement si nécessaire */
    box-sizing: border-box;
}

.col-header {
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;;qEAGqE;;;AAGrE;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;;AAEnC,mBAAmB,cAAc,EAAE,gBAAgB,EAAE;AACrD,mBAAmB,cAAc,EAAE,gBAAgB,EAAE;AACrD,mBAAmB,cAAc,EAAE,gBAAgB,EAAE;;AAErD;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,WAAW;IACX,2BAA2B;AAC/B;;AAEA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD;IACI,8EAA8E;IAC9E,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,2BAA2B;AAC/B;;AAEA,aAAa,iBAAiB,EAAE,cAAc,EAAE,aAAa,EAAE;AAC/D,mBAAmB,cAAc,EAAE,eAAe,EAAE;;AAEpD;IACI,gFAAgF;IAChF,YAAY,EAAE,aAAa,EAAE,mBAAmB;IAChD,mBAAmB,EAAE,0CAA0C;AACnE;AACA,aAAa,iBAAiB,EAAE,kBAAkB,EAAE;;AAEpD;IACI,uBAAuB,EAAE,kBAAkB,EAAE,mBAAmB;IAChE,mBAAmB,EAAE,aAAa,EAAE,SAAS;IAC7C,eAAe,EAAE,mBAAmB,EAAE,qCAAqC;AAC/E;;AAEA;IACI,kBAAkB,EAAE,YAAY,EAAE,kBAAkB;IACpD,gBAAgB,EAAE,eAAe,EAAE,oBAAoB;IACvD,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;AACxE;AACA,aAAa,2BAA2B,EAAE,uCAAuC,EAAE;AACnF,eAAe,0BAA0B,EAAE,YAAY,EAAE;AACzD,eAAe,0BAA0B,EAAE,YAAY,EAAE;AACzD,eAAe,0BAA0B,EAAE,YAAY,EAAE;AACzD,cAAc,yBAAyB,EAAE,YAAY,EAAE;AACvD,iBAAiB,4BAA4B,EAAE,YAAY,EAAE;AAC7D,aAAa,iBAAiB,EAAE,eAAe,EAAE;AACjD,aAAa,eAAe,EAAE;;AAE9B,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9D,gBAAgB,kBAAkB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC1G,4BAA4B,aAAa,EAAE,4BAA4B,EAAE;;AAEzE,uDAAuD;AACvD;IACI,uBAAuB,EAAE,mBAAmB,EAAE,aAAa;IAC3D,kBAAkB,EAAE,qCAAqC;IACzD,kBAAkB,EAAE,eAAe;AACvC;AACA,iBAAiB,aAAa,EAAE,QAAQ,EAAE,sBAAsB,EAAE;;AAElE;IACI,SAAW,EAAE,gBAAgB;IAC7B,+BAA+B,EAAE,kBAAkB;IACnD,gBAAgB,EAAE,iBAAiB;AACvC;AACA;IACI,gFAAgF;IAChF,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;AACrF;;AAEA,aAAa,aAAa,EAAE;AAC5B,kBAAkB,aAAa,EAAE;;AAEjC;IACI,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB;IAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,eAAe,EAAE,oBAAoB;AACzC;AACA,cAAc,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AAChE,cAAc,gBAAgB,EAAE,eAAe,EAAE;;AAEjD,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC3F,sDAAsD,0CAA0C,EAAE,mBAAmB,EAAE;;AAEvH,WAAW,uGAAuG,EAAE,0BAA0B,EAAE;AAChJ,WAAW,8BAA8B,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACpH,YAAY,8BAA8B,EAAE,yBAAyB,EAAE;AACvE,aAAa,8BAA8B,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACxF,cAAc,8BAA8B,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;;AAEzF,cAAc,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE,+BAA+B,EAAE;AACvK,qBAAqB,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACrG,kBAAkB,uCAAuC,EAAE;;AAE3D,qBAAqB;AACrB;IACI,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB;IAC1D,mBAAmB,EAAE,qCAAqC;IAC1D,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,mBAAmB;AAClE;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE;AACnG,qBAAqB,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACjE,cAAc,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACzF,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,oBAAoB,qBAAqB,EAAE,gBAAgB,EAAE;;AAE7D,gBAAgB;AAChB,eAAe,eAAe,EAAE,iBAAiB,EAAE;AACnD,eAAe,kCAAkC,EAAE;AACnD,yBAAyB,WAAW,2CAA2C,EAAE,EAAE,MAAM,2CAA2C,EAAE,EAAE;;AAExI,eAAe;AACf;IACI,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB;IAC1D,mBAAmB,EAAE,qCAAqC;IAC1D,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,mBAAmB;AAClE;AACA,gBAAgB,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAC1E,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC/E,cAAc,iBAAiB,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACzM,iBAAiB,mBAAmB,EAAE,4BAA4B,EAAE,qBAAqB,EAAE;AAC3F,iBAAiB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE,YAAY,EAAE;AAC3F,iBAAiB,gBAAgB,EAAE,eAAe,EAAE;AACpD,oBAAoB,2BAA2B,EAAE;;AAEjD,UAAU;AACV,SAAS,eAAe,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS,EAAE,2BAA2B,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE;AACzK,iBAAiB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,UAAU,EAAE,uCAAuC,EAAE;AAC/I,gBAAgB,mBAAmB,EAAE,oBAAoB,EAAE,sCAAsC,EAAE;;AAEnG,cAAc,mBAAmB,EAAE;AACnC,oBAAoB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1F,wCAAwC,WAAW,EAAE;;AAErD,mBAAmB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gFAAgF,EAAE;AACrL,cAAc,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,uCAAuC,EAAE,gBAAgB,EAAE,UAAU,EAAE;AACjJ,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAErG,SAAS,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACxF,iBAAiB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACjF,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE/E,UAAU,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qCAAqC,EAAE;AAC1H,aAAa,mBAAmB,EAAE,eAAe,EAAE;AACnD,eAAe,aAAa,EAAE,2DAA2D,EAAE,QAAQ,EAAE;AACrG,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC9E,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,+BAA+B,EAAE;;AAEhG,WAAW,kBAAkB,EAAE,aAAa,EAAE;AAC9C,WAAW,yBAAyB,EAAE,oCAAoC,EAAE,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,kCAAkC,EAAE,mBAAmB,EAAE;AACpL,kBAAkB,KAAK,uBAAuB,EAAE,EAAE,OAAO,yBAAyB,EAAE,EAAE;;AAEtF,cAAc,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qCAAqC,EAAE;AAC9H,cAAc,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE;AACrG,aAAa,aAAa,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,qCAAqC,EAAE;AAC9G,cAAc,eAAe,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACzH,cAAc,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACxE,yBAAyB,SAAO,EAAE,gBAAgB,EAAE;AACpD,iBAAiB,kBAAkB,EAAE,qBAAqB,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE;AAC5J,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAClF,yCAAyC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AACrF,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AAC5E,mBAAmB,uBAAuB,EAAE,kBAAkB,EAAE;AAChE,YAAY,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAChN,qBAAqB,YAAY,EAAE,mBAAmB,EAAE;AACxD,gBAAgB,eAAe,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC/E,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE;AAC5J,iBAAiB,gBAAgB,EAAE,uBAAuB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC9F,gBAAgB,SAAO,EAAE,gBAAgB,EAAE;AAC3C,kBAAkB,eAAe,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE9F,eAAe,aAAa,EAAE,2DAA2D,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC1H,eAAe,kBAAkB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC/F,sBAAsB,qBAAqB,EAAE;AAC7C,oBAAoB,cAAc,EAAE;AACpC,uBAAuB,kBAAkB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC/E,yBAAyB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACpE,0BAA0B,gBAAgB,EAAE,0BAA0B,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AAC/M,iBAAiB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA+C9E;;iDAEiD;AACjD;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;4GAC4G;AAC5G,yCAAyC,iCAAiC,EAAE;AAC5E,oDAAoD,cAAc,EAAE,iBAAiB,EAAE;AACvF,2CAA2C,iBAAiB,EAAE;AAC9D,+CAA+C,UAAU,EAAE,WAAW,EAAE;;AAExE;;iDAEiD;AACjD;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;;iDAEiD;AACjD;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAuCA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;;;;;AAMA;;iDAEiD;AACjD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;;iDAEiD;AACjD;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;iDAEiD;AACjD;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;AAC9C;;AAEA;;iDAEiD;AACjD;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;IACpE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,mBAAmB,EAAE;AAC/B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,cAAc;AACd;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA,UAAU;AACV;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;;;;;;;;;;;AAYA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;;iDAEiD;AACjD;IACI,yEAAyE;IACzE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;iDAEiD;AACjD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gFAAgF;IAChF,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;iDAEiD;AACjD;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;iDAEiD;AACjD;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;iDAEiD;AACjD;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gFAAgF;AACpF;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iCAAiC;AACrC;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;CACjB,mBAAmB;AACpB;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;iDAEiD;AACjD;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;iDAEiD;AACjD;IACI,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;iFAEiF;;AAEjF;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;kFAEkF;;AAElF,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,YAAY,WAAW,EAAE,kBAAkB,EAAE;AAC7C,gBAAgB,WAAW,EAAE;AAC7B,YAAY,YAAY,EAAE;AAC1B,qBAAqB,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAE/F;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,cAAc,WAAW,EAAE;;AAE3B;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;kFAEkF;;AAElF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;kFAEkF;;AAElF;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;kFAEkF;;AAElF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;;;;;;gBAMY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uEAAuE;IACvE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;;QAEI,sEAAsE;QACtE,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;iDAEiD;AACjD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB,EAAE,+CAA+C;AACvE;;AAEA,iDAAiD;AACjD;IACI,cAAc,SAAS,oBAAoB;IAC3C,YAAY,WAAW,mBAAmB;IAC1C,WAAW,YAAY,6CAA6C;IACpE,sBAAsB,EAAE,qCAAqC;AACjE;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,6CAA6C;IAC7C,QAAQ;AACZ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,6CAA6C;IAC7C,QAAQ;AACZ;;AAEA,2CAA2C;AAC3C;CACC,gFAAgF;IAC7E,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;IACjF,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI,YAAY,EAAE,2CAA2C;IACzD,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["\n:root {\n    --primary: #1e40af;\n    --primary-dark: #1e3a8a;\n    --secondary: #64748b;\n    --success: #10b981;\n    --danger: #ef4444;\n    --warning: #f59e0b;\n    --bg: #f8fafc;\n    --card: #ffffff;\n    --border: #e2e8f0;\n}\n\n/* ============================================\n   STICKY TOP - Zone figée\n   ============================================ */\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: var(--bg);\n    padding-bottom: 8px;\n}\n\n/* Les regles `.dashboard-row`, `.dashboard-left`, `.dashboard-right` et\n   `.dashboard-split-divider` ont ete RETIREES au lot 5.5, avec le curseur de\n   separation qu'elles habillaient (decision D2 : il n'est pas dans la maquette).\n   La zone haute est desormais `.pl-topzone`, dans PlanningApp.css. */\n\n\n/* ============================================\n   DASHBOARD CONTENT\n   ============================================ */\n.dashboard-content {\n    background: var(--card);\n    border-radius: 12px;\n    padding: 12px 16px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    display: flex;\n    gap: 20px;\n    align-items: flex-start;\n    height: 100%;\n}\n\n.dashboard-compteurs {\n    flex: 0 0 auto;\n    min-width: 250px;\n}\n\n.dashboard-indicateurs {\n    flex: 1;\n    min-width: 200px;\n}\n\n.dashboard-title {\n    font-size: 0.9rem;\n    color: var(--primary);\n    margin-bottom: 8px;\n    font-weight: 700;\n}\n\n/* Tableau compteurs */\n.dashboard-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n}\n\n.dashboard-table th {\n    padding: 5px 8px;\n    text-align: center;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: var(--secondary);\n    border-bottom: 2px solid var(--border);\n}\n\n.dashboard-table th:first-child {\n    text-align: left;\n}\n\n.dashboard-table td {\n    padding: 4px 8px;\n    text-align: center;\n    border-bottom: 1px solid var(--border);\n}\n\n.dashboard-table td:first-child {\n    text-align: left;\n    font-weight: 600;\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.dashboard-groupe-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.dashboard-col-f { color: #1e293b; }\n.dashboard-col-e { color: #64748b; }\n.dashboard-col-s { color: #7C3AED; }\n\n.dashboard-val-f { color: #1e293b; font-weight: 600; }\n.dashboard-val-e { color: #64748b; font-weight: 600; }\n.dashboard-val-s { color: #7C3AED; font-weight: 600; }\n\n.dashboard-total-row {\n    background: var(--bg);\n}\n\n.dashboard-total-row td {\n    border-top: 2px solid var(--primary);\n    border-bottom: none;\n    padding: 6px 8px;\n}\n\n.dashboard-no-data {\n    text-align: center;\n    padding: 15px;\n    color: var(--secondary);\n    font-size: 13px;\n    background: var(--bg);\n    border-radius: 8px;\n}\n\n/* Placeholder indicateurs */\n.dashboard-placeholder {\n    background: var(--bg);\n    border: 2px dashed var(--border);\n    border-radius: 10px;\n    padding: 15px;\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n}\n\n.dashboard-placeholder-icon {\n    font-size: 1.8rem;\n    flex-shrink: 0;\n}\n\n.dashboard-placeholder-text {\n    font-size: 12px;\n    color: var(--secondary);\n}\n\n.dashboard-placeholder-text p {\n    margin-bottom: 4px;\n}\n\n.dashboard-placeholder-text ul {\n    margin: 0;\n    padding-left: 18px;\n}\n\n.dashboard-placeholder-text li {\n    margin-bottom: 2px;\n    font-size: 11px;\n}\n\n/* ============================================\n   FILTRES - Colonnes par niveau\n   ============================================ */\n.filter-panel {\n    background: var(--card);\n    border-radius: 12px;\n    padding: 10px 16px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    height: 100%;\n}\n\n.filter-niveaux-grid {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.filter-niveau-column {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 100px;\n}\n\n.filter-niveau-btn {\n    font-weight: 700 !important;\n    font-size: 12px !important;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 3px;\n}\n\n.filter-groupes-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding-left: 8px;\n    border-left: 3px solid var(--border);\n}\n\n.filter-groupe-btn {\n    font-size: 10px !important;\n    padding: 3px 8px !important;\n    width: 100%;\n    justify-content: flex-start;\n}\n\n/* ============================================\n   CALENDAR STATUS BAR (compact)\n   ============================================ */\n.calendar-status-bar {\n    background: var(--card);\n    padding: 5px 15px;\n    border-radius: 8px;\n    margin-bottom: 6px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: wrap;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n    font-size: 12px;\n}\n\n.calendar-edit-hints {\n    display: flex;\n    gap: 12px;\n    color: #475569;\n    flex-wrap: wrap;\n}\n\n.calendar-edit-hints span {\n    font-size: 11px;\n}\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    background: var(--bg);\n    color: #1e293b;\n}\n\n/* ============================================\n   FILTRES - Colonnes par niveau\n   ============================================ */\n.filter-panel {\n    background: var(--card);\n    border-radius: 12px;\n    padding: 12px 20px;\n    margin-bottom: 12px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.filter-niveaux-grid {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.filter-niveau-column {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 120px;\n}\n\n.filter-niveau-btn {\n    font-weight: 700 !important;\n    font-size: 13px !important;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 4px;\n}\n\n.filter-groupes-list {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding-left: 8px;\n    border-left: 3px solid var(--border);\n}\n\n.filter-groupe-btn {\n    font-size: 11px !important;\n    padding: 4px 10px !important;\n    width: 100%;\n    justify-content: flex-start;\n}\n\n.container { max-width: 1920px; margin: 0 auto; padding: 20px; }\n.container-fluid { margin: 0 20px; padding: 20px 0; }\n\n.header {\n    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n    color: white; padding: 30px; border-radius: 12px;\n    margin-bottom: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);\n}\n.header h1 { font-size: 1.8rem; margin-bottom: 8px; }\n\n.toolbar {\n    background: var(--card); padding: 15px 20px; border-radius: 12px;\n    margin-bottom: 15px; display: flex; gap: 15px;\n    flex-wrap: wrap; align-items: center; box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.btn {\n    padding: 10px 20px; border: none; border-radius: 8px;\n    font-weight: 600; cursor: pointer; transition: all 0.2s;\n    font-size: 14px; display: inline-flex; align-items: center; gap: 8px;\n}\n.btn:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }\n.btn-primary { background: var(--primary); color: white; }\n.btn-success { background: var(--success); color: white; }\n.btn-warning { background: var(--warning); color: white; }\n.btn-danger { background: var(--danger); color: white; }\n.btn-secondary { background: var(--secondary); color: white; }\n.btn-small { padding: 6px 14px; font-size: 13px; }\n.btn-large { font-size: 16px; }\n\n.input-group { display: flex; align-items: center; gap: 10px; }\ninput, select { padding: 10px 15px; border: 2px solid var(--border); border-radius: 8px; font-size: 14px; }\ninput:focus, select:focus { outline: none; border-color: var(--primary); }\n\n/* Calendar wrapper - pleine largeur avec scroll auto */\n.calendar-wrapper {\n    background: var(--card); border-radius: 12px; padding: 15px;\n    overflow-x: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    position: relative; cursor: default;\n}\n.calendar-grid { display: flex; gap: 2px; min-width: max-content; }\n\n.month-column {\n    flex: 1 1 0; min-width: 120px;\n    border: 1px solid var(--border); border-radius: 6px;\n    overflow: hidden; background: white;\n}\n.month-header {\n    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n    color: white; padding: 8px; text-align: center; font-weight: 700; font-size: 12px;\n}\n\n.days-grid { display: grid; }\n.column-headers { display: grid; }\n\n.day-cell {\n    border: 1px solid #f0f0f0; padding: 3px 2px; min-height: 26px;\n    display: flex; align-items: center; justify-content: center;\n    font-size: 10px; transition: all 0.1s;\n}\n.day-letter { font-weight: 700; color: #64748b; font-size: 9px; }\n.day-number { font-weight: 600; font-size: 10px; }\n\n.interactive-cell { cursor: pointer; font-weight: 700; font-size: 11px; user-select: none; }\n.interactive-cell:hover:not(.weekend):not(.holiday) { box-shadow: inset 0 0 0 2px var(--primary); background: #f0f7ff; }\n\n.weekend { background: repeating-linear-gradient(45deg, #f1f5f9, #f1f5f9 4px, #e2e8f0 4px, #e2e8f0 8px) !important; cursor: default !important; }\n.holiday { background: #fee2e2 !important; color: #991b1b !important; font-weight: 700; cursor: default !important; }\n.vacation { background: #dbeafe !important; color: #1e40af !important; }\n.formation { background: #1e293b !important; color: white !important; font-weight: 700; }\n.entreprise { background: #94a3b8 !important; color: white !important; font-weight: 700; }\n\n.col-header { padding: 4px 2px; text-align: center; font-size: 9px; font-weight: 700; color: var(--secondary); background: var(--bg); border: 1px solid var(--border); }\n.col-header-groupe { font-size: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.column-headers { border-bottom: 2px solid var(--primary); }\n\n/* Instructions bar */\n.instructions-bar {\n    background: white; padding: 10px 20px; border-radius: 12px;\n    margin-bottom: 10px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    display: flex; flex-wrap: wrap; gap: 15px; align-items: center;\n}\n.instruction-item { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #475569; }\n.instruction-stats { display: flex; gap: 8px; margin-left: auto; }\n.stat-badge { padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; }\n.formation-badge { background: #1e293b; color: white; }\n.entreprise-badge { background: #94a3b8; color: white; }\n.saving-indicator { color: var(--warning); font-weight: 600; }\n\n/* Edit toggle */\n.edit-toggle { font-size: 13px; padding: 8px 16px; }\n.edit-active { animation: pulse-green 2s infinite; }\n@keyframes pulse-green { 0%, 100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4); } 50% { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0); } }\n\n/* Filter bar */\n.filter-bar {\n    background: white; padding: 10px 20px; border-radius: 12px;\n    margin-bottom: 10px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    display: flex; flex-wrap: wrap; gap: 10px; align-items: center;\n}\n.filter-label { font-weight: 700; color: var(--primary); font-size: 13px; }\n.filter-group { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }\n.filter-btn { padding: 5px 10px; border: 2px solid var(--border); border-radius: 20px; background: white; cursor: pointer; font-size: 11px; font-weight: 600; transition: all 0.2s; white-space: nowrap; }\n.filter-active { background: #f0f7ff; border-color: var(--primary); color: var(--primary); }\n.filter-hidden { background: #f8f9fa; color: #adb5bd; border-color: #dee2e6; opacity: 0.7; }\n.filter-niveau { font-weight: 700; font-size: 12px; }\n.filter-btn:hover { transform: translateY(-1px); }\n\n/* Modal */\n.modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }\n.modal-content { background: white; padding: 30px; border-radius: 16px; max-width: 500px; width: 90%; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }\n.modal-header { margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px solid var(--border); }\n\n.form-group { margin-bottom: 15px; }\n.form-group label { display: block; margin-bottom: 8px; font-weight: 600; color: #475569; }\n.form-group input, .form-group select { width: 100%; }\n\n.login-container { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%); }\n.login-card { background: white; padding: 48px 52px; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); max-width: 640px; width: 90%; }\n.login-card h1 { margin-bottom: 30px; color: var(--primary); white-space: nowrap; font-size: 1.6rem; }\n\n.alert { padding: 12px 16px; border-radius: 8px; margin-bottom: 15px; font-weight: 500; }\n.alert-success { background: #d1fae5; color: #065f46; border: 1px solid #10b981; }\n.alert-error { background: #fee2e2; color: #991b1b; border: 1px solid #ef4444; }\n\n.legend { background: white; padding: 15px; border-radius: 12px; margin-top: 15px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }\n.legend h3 { margin-bottom: 10px; font-size: 1rem; }\n.legend-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 8px; }\n.legend-item { display: flex; align-items: center; gap: 8px; font-size: 13px; }\n.legend-color { width: 25px; height: 16px; border-radius: 3px; border: 1px solid var(--border); }\n\n.loading { text-align: center; padding: 40px; }\n.spinner { border: 4px solid #f3f3f3; border-top: 4px solid var(--primary); border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto 20px; }\n@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }\n\n.stats-card { background: white; padding: 15px; border-radius: 12px; margin-top: 15px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }\n.stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 10px; }\n.stat-item { padding: 12px; background: var(--bg); border-radius: 8px; border-left: 4px solid var(--primary); }\n.stat-label { font-size: 11px; color: var(--secondary); margin-bottom: 4px; text-transform: uppercase; font-weight: 600; }\n.stat-value { font-size: 20px; font-weight: 700; color: var(--primary); }\n.setup-row .form-group { flex: 1; min-width: 200px; }\n.niveau-header { padding: 12px 16px; background: var(--bg); display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; }\n.checkbox-label { display: flex; align-items: center; gap: 10px; cursor: pointer; }\n.checkbox-label input[type=\"checkbox\"] { width: 18px; height: 18px; cursor: pointer; }\n.niveau-title { font-weight: 700; font-size: 1.1rem; color: var(--primary); }\n.niveau-subtitle { color: var(--secondary); font-size: 0.85rem; }\n.btn-icon { width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 700; transition: all 0.2s; }\n.btn-icon:disabled { opacity: 0.3; cursor: not-allowed; }\n.groupes-info { font-size: 13px; color: var(--secondary); margin-bottom: 12px; }\n.single-group { color: var(--success); }\n.groupes-list { display: flex; flex-direction: column; gap: 8px; }\n.groupe-item { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: var(--bg); border-radius: 8px; border: 1px solid var(--border); }\n.groupe-numero { font-weight: 700; color: var(--secondary); font-size: 13px; min-width: 22px; }\n.groupe-input { flex: 1; min-width: 120px; }\n.groupe-preview { font-size: 12px; color: var(--primary); font-weight: 600; min-width: 100px; }\n\n.resume-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 8px; margin-bottom: 15px; }\n.resume-item { padding: 10px 12px; background: var(--bg); border-radius: 8px; font-size: 13px; }\n.resume-item strong { color: var(--primary); }\n.colonnes-preview { margin: 15px 0; }\n.colonnes-preview h3 { font-size: 0.95rem; margin-bottom: 8px; color: #475569; }\n.colonnes-preview-grid { display: flex; gap: 2px; overflow-x: auto; }\n.colonne-preview-header { padding: 8px 6px; background: var(--primary); color: white; font-weight: 700; font-size: 11px; text-align: center; min-width: 70px; border-radius: 4px 4px 0 0; white-space: nowrap; }\n.setup-buttons { display: flex; gap: 12px; margin-top: 15px; flex-wrap: wrap; }\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ============================================\n   ÉVÉNEMENTS - PASTILLES SUR LE CALENDRIER\n   ============================================ */\n.day-number {\n    position: relative;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.day-number-text {\n    line-height: 1;\n}\n\n.has-events {\n    padding-bottom: 2px;\n}\n\n.event-pastilles {\n    display: flex;\n    gap: 2px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.event-pastille {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: transform 0.2s;\n    border: 1px solid rgba(255,255,255,0.5);\n    flex-shrink: 0;\n}\n\n.event-pastille:hover {\n    transform: scale(1.5);\n}\n\n/* PA.0 (2026-10-28) : le calendrier tient dans la hauteur de la fenêtre — Calendar.js calcule --pl-ligne (16 à 26 px).\n   Hauteur MINIMALE seulement : une date chargée d'événements agrandit encore sa ligne, rien n'est masqué. */\n.calendar-wrapper .days-grid .day-cell { min-height: var(--pl-ligne, 26px); }\n.calendar-wrapper.cal-ajuste .days-grid .day-cell { padding-top: 0; padding-bottom: 0; }\n.calendar-wrapper.cal-ajuste .has-events { padding-bottom: 0; }\n.calendar-wrapper.cal-ajuste .event-pastille { width: 6px; height: 6px; }\n\n/* ============================================\n   ÉVÉNEMENTS - TOOLTIP\n   ============================================ */\n.event-tooltip {\n    position: fixed;\n    z-index: 9999;\n    background: #1e293b;\n    color: white;\n    padding: 6px 12px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    pointer-events: none;\n    white-space: nowrap;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.event-tooltip-icon {\n    font-size: 14px;\n}\n\n/* ============================================\n   ÉVÉNEMENTS - CONTEXT MENU\n   ============================================ */\n.event-context-menu {\n    position: fixed;\n    z-index: 10000;\n    background: white;\n    border: 1px solid var(--border);\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0,0,0,0.15);\n    overflow: hidden;\n    min-width: 160px;\n}\n\n.context-menu-item {\n    padding: 10px 15px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    transition: background 0.15s;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.context-menu-item:hover {\n    background: var(--bg);\n}\n\n.context-menu-danger {\n    color: var(--danger);\n}\n\n.context-menu-danger:hover {\n    background: #fee2e2;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-2px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n\n\n\n\n/* ============================================\n   HEADER - NOM DÉPARTEMENT\n   ============================================ */\n.header-dept-name {\n    font-size: 1.4rem;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 0.9);\n    margin: 4px 0 8px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n}\n/* ============================================\n   STAGE - CELLULE\n   ============================================ */\n.stage {\n    background: #7C3AED !important;\n    color: white !important;\n    font-weight: 700;\n}\n\n.stage-badge {\n    background: #7C3AED;\n    color: white;\n}\n\n/* ============================================\n   DATE CLICKABLE\n   ============================================ */\n.date-clickable {\n    cursor: pointer;\n    transition: all 0.15s;\n}\n\n.date-clickable:hover {\n    background: #dbeafe !important;\n    box-shadow: inset 0 0 0 2px var(--primary);\n}\n\n/* ============================================\n   DATE EVENT PICKER - POPUP\n   ============================================ */\n.date-event-picker {\n    position: fixed;\n    z-index: 950;\n    width: 310px;\n    max-height: 400px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 12px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.05);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: pickerAppear 0.15s ease-out;\n}\n\n@keyframes pickerAppear {\n    from { opacity: 0; transform: scale(0.95) translateY(-5px); }\n    to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.dep-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    background: var(--primary);\n    color: white;\n}\n\n.dep-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n}\n\n.dep-hint {\n    padding: 8px 14px;\n    background: #FEF3C7;\n    color: #92400E;\n    font-size: 11px;\n    font-weight: 600;\n    text-align: center;\n    animation: hintPulse 2s infinite;\n}\n\n@keyframes hintPulse {\n    0%, 100% { background: #FEF3C7; }\n    50% { background: #FDE68A; }\n}\n\n.dep-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px;\n}\n\n.dep-section {\n    margin-bottom: 8px;\n}\n\n.dep-section-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--secondary);\n    padding: 4px 6px;\n    text-transform: uppercase;\n}\n\n.dep-event-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 10px;\n    border: 1px solid var(--border);\n    border-left: 4px solid var(--primary);\n    border-radius: 6px;\n    margin-bottom: 4px;\n    cursor: pointer;\n    transition: all 0.15s;\n    font-size: 12px;\n}\n\n.dep-event-item:hover {\n    background: #EFF6FF;\n    border-color: var(--primary);\n    transform: translateX(3px);\n}\n\n.dep-event-placed {\n    background: #F9FAFB;\n    opacity: 0.8;\n}\n\n.dep-event-placed:hover {\n    opacity: 1;\n    background: #FEF3C7;\n}\n\n.dep-event-icon {\n    font-size: 1rem;\n    flex-shrink: 0;\n}\n\n.dep-event-label {\n    flex: 1;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.dep-event-old-date {\n    font-size: 10px;\n    color: var(--secondary);\n    background: var(--bg);\n    padding: 2px 6px;\n    border-radius: 8px;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.dep-event-delete {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 2px;\n    opacity: 0.4;\n    transition: opacity 0.2s;\n    flex-shrink: 0;\n}\n\n.dep-event-delete:hover {\n    opacity: 1;\n}\n\n.dep-empty {\n    text-align: center;\n    padding: 15px;\n    color: var(--secondary);\n    font-size: 12px;\n}\n\n.dep-create-btn {\n    width: 100%;\n    padding: 8px;\n    border: 2px dashed var(--border);\n    border-radius: 6px;\n    background: none;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--secondary);\n    transition: all 0.2s;\n    margin-top: 4px;\n}\n\n.dep-create-btn:hover {\n    border-color: var(--primary);\n    color: var(--primary);\n    background: #EFF6FF;\n}\n\n.dep-create-form {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    margin-top: 4px;\n    flex-wrap: wrap;\n}\n\n.dep-create-select {\n    padding: 5px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    font-size: 11px;\n    min-width: 100px;\n}\n\n.dep-create-input {\n    flex: 1;\n    padding: 5px 8px;\n    border: 2px solid var(--primary);\n    border-radius: 4px;\n    font-size: 12px;\n    min-width: 80px;\n}\n\n/* ============================================\n   ADMIN PANEL\n   ============================================ */\n.admin-section {\n    margin-top: 15px;\n}\n\n.admin-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.admin-section-header h2 {\n    font-size: 1.3rem;\n    color: var(--primary);\n}\n\n/* Form card */\n.admin-form-card {\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    margin-bottom: 15px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n    border: 2px solid var(--primary);\n}\n\n.admin-form-card h3 {\n    font-size: 1rem;\n    color: var(--primary);\n    margin-bottom: 15px;\n}\n\n.admin-form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 15px;\n}\n\n.admin-form-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 15px;\n}\n\n/* Dept selector */\n.admin-depts-selector {\n    margin-top: 12px;\n}\n\n.admin-depts-selector > label {\n    display: block;\n    font-weight: 600;\n    color: #475569;\n    margin-bottom: 8px;\n    font-size: 13px;\n}\n\n.admin-depts-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.admin-dept-chip {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 2px solid var(--border);\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.2s;\n    user-select: none;\n}\n\n.admin-dept-chip:hover {\n    border-color: var(--primary);\n}\n\n.admin-dept-chip input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n}\n\n.admin-dept-selected {\n    background: #dbeafe;\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n/* Table */\n.admin-table {\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.admin-table table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.admin-table th {\n    background: var(--bg);\n    padding: 12px 15px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--secondary);\n    text-transform: uppercase;\n    border-bottom: 2px solid var(--border);\n}\n\n.admin-table td {\n    padding: 10px 15px;\n    border-bottom: 1px solid var(--border);\n    font-size: 13px;\n}\n\n.admin-table tr:hover {\n    background: #f8fafc;\n}\n\n.admin-row-inactive {\n    opacity: 0.5;\n}\n\n.admin-cell-email {\n    font-weight: 600;\n    color: var(--primary);\n}\n\n/* Role badges */\n.admin-role-badge {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.admin-role-admin {\n    background: #FEE2E2;\n    color: #991B1B;\n}\n\n.admin-role-gestionnaire {\n    background: #DBEAFE;\n    color: #1E40AF;\n}\n\n.admin-role-lecture {\n    background: #F3F4F6;\n    color: #6B7280;\n}\n\n/* Status */\n.admin-status {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.admin-status-active {\n    color: var(--success);\n}\n\n.admin-status-inactive {\n    color: var(--danger);\n}\n\n/* Dept tags */\n.admin-dept-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n.admin-dept-tag {\n    padding: 2px 8px;\n    background: var(--bg);\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 700;\n    color: var(--primary);\n    border: 1px solid var(--border);\n}\n\n.admin-dept-all {\n    background: #FEF3C7;\n    color: #92400E;\n    border-color: #F59E0B;\n}\n\n/* Actions */\n.admin-actions {\n    display: flex;\n    gap: 4px;\n}\n\n/* Dept select in toolbar */\n.admin-dept-select {\n    padding: 8px 12px;\n    border: 2px solid var(--border);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    min-width: 200px;\n}\n\n/* Dept cards */\n.admin-dept-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 15px;\n}\n\n.admin-dept-card {\n    background: white;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    border: 2px solid var(--border);\n    transition: all 0.2s;\n}\n\n.admin-dept-card:hover {\n    border-color: var(--primary);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.admin-dept-card-inactive {\n    opacity: 0.5;\n}\n\n.admin-dept-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 8px;\n}\n\n.admin-dept-card-code {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--secondary);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.admin-dept-card-name {\n    font-size: 1.1rem;\n    color: var(--primary);\n    margin-top: 2px;\n}\n\n.admin-dept-card-desc {\n    font-size: 12px;\n    color: var(--secondary);\n    margin-bottom: 10px;\n}\n\n.admin-dept-card-stats {\n    display: flex;\n    gap: 15px;\n    font-size: 12px;\n    color: var(--secondary);\n    margin-bottom: 12px;\n    padding: 8px 0;\n    border-top: 1px solid var(--border);\n    border-bottom: 1px solid var(--border);\n}\n\n.admin-dept-card-actions {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n\n\n\n\n\n\n\n\n\n\n/* ============================================\n   CALENDAR STATUS BAR (compact)\n   ============================================ */\n.calendar-status-bar {\n    background: var(--card);\n    padding: 6px 15px;\n    border-radius: 8px;\n    margin-bottom: 6px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: wrap;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n    font-size: 12px;\n}\n\n.calendar-edit-hints {\n    display: flex;\n    gap: 12px;\n    color: #475569;\n    flex-wrap: wrap;\n}\n\n.calendar-edit-hints span {\n    font-size: 12px;\n}\n\n.calendar-status-stats {\n    display: flex;\n    gap: 6px;\n    margin-left: auto;\n}\n\n/* ============================================\n   FOOTER\n   ============================================ */\n.app-footer {\n    background: linear-gradient(135deg, var(--primary-dark) 0%, #0f172a 100%);\n    color: rgba(255, 255, 255, 0.8);\n    padding: 15px 20px;\n    margin-top: 30px;\n    border-radius: 12px 12px 0 0;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    max-width: 1920px;\n    margin: 0 auto;\n}\n\n.footer-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.footer-copyright {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.footer-version {\n    font-size: 10px;\n    background: rgba(255, 255, 255, 0.15);\n    padding: 2px 8px;\n    border-radius: 8px;\n    font-weight: 600;\n}\n\n.footer-links {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.footer-link {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 12px;\n    cursor: pointer;\n    padding: 2px 4px;\n    border-radius: 4px;\n    transition: all 0.2s;\n    font-weight: 500;\n    text-decoration: none;\n}\n\n.footer-link:hover {\n    color: white;\n    background: rgba(255, 255, 255, 0.1);\n    text-decoration: underline;\n}\n\n.footer-dot {\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 10px;\n}\n\n.footer-right {\n    font-size: 12px;\n}\n\n.footer-email {\n    color: rgba(255, 255, 255, 0.9);\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.footer-email:hover {\n    text-decoration: underline;\n    color: white;\n}\n\n.footer-contact {\n    font-size: 12px;\n}\n\n/* ============================================\n   MODALES LÉGALES\n   ============================================ */\n.legal-modal {\n    background: white;\n    border-radius: 16px;\n    max-width: 800px;\n    width: 95%;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    overflow: hidden;\n}\n\n.legal-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 25px;\n    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n    color: white;\n}\n\n.legal-modal-header h2 {\n    font-size: 1.3rem;\n    margin: 0;\n}\n\n.legal-modal-close {\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: white;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s;\n}\n\n.legal-modal-close:hover {\n    background: rgba(255, 255, 255, 0.4);\n}\n\n.legal-modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 25px;\n}\n\n.legal-modal-footer {\n    padding: 15px 25px;\n    border-top: 1px solid var(--border);\n    display: flex;\n    justify-content: flex-end;\n}\n\n/* ============================================\n   CONTENU LÉGAL\n   ============================================ */\n.legal-content section {\n    margin-bottom: 25px;\n}\n\n.legal-content section:last-child {\n    margin-bottom: 0;\n}\n\n.legal-content h3 {\n    font-size: 1rem;\n    color: var(--primary);\n    margin-bottom: 10px;\n    padding-bottom: 6px;\n    border-bottom: 2px solid var(--border);\n}\n\n.legal-content p {\n    font-size: 14px;\n    line-height: 1.7;\n    color: #334155;\n    margin-bottom: 10px;\n}\n\n.legal-content ul {\n    margin: 8px 0;\n    padding-left: 24px;\n}\n\n.legal-content li {\n    font-size: 14px;\n    line-height: 1.7;\n    color: #334155;\n    margin-bottom: 4px;\n}\n\n.legal-content a {\n    color: var(--primary);\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.legal-content a:hover {\n    text-decoration: underline;\n}\n\n.legal-content code {\n    background: var(--bg);\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 13px;\n    color: var(--primary);\n    font-weight: 600;\n}\n\n.legal-content strong {\n    color: #1e293b;\n}\n\n/* Tableaux légaux */\n.legal-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 10px 0;\n    font-size: 13px;\n}\n\n.legal-table th {\n    background: var(--bg);\n    padding: 10px 12px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--primary);\n    border-bottom: 2px solid var(--border);\n}\n\n.legal-table td {\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--border);\n    color: #334155;\n    line-height: 1.5;\n}\n\n.legal-table tr:hover {\n    background: #f8fafc;\n}\n\n/* ============================================\n   FOOTER RESPONSIVE\n   ============================================ */\n@media (max-width: 768px) {\n    .footer-content {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .footer-links {\n        justify-content: center;\n    }\n\n    .legal-modal {\n        width: 100%;\n        max-height: 95vh;\n        border-radius: 12px 12px 0 0;\n    }\n\n    .legal-modal-body {\n        padding: 15px;\n    }\n\n    .legal-table {\n        font-size: 11px;\n    }\n\n    .legal-table th,\n    .legal-table td {\n        padding: 6px 8px;\n    }\n}\n\n/* ============================================\n   LOGIN PAGE - Layout avec footer\n   ============================================ */\n.login-page {\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n}\n\n.login-page .login-container {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-page .app-footer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    margin-top: 0;\n    border-radius: 0;\n    background: rgba(0, 0, 0, 0.3);\n    z-index: 10;\n}\n\n.type-journee-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background: var(--bg);\n    border-radius: 8px;\n    border: 1px solid var(--border);\n}\n\n.type-journee-code-wrapper {\n    flex: 0 0 auto;\n}\n\n.type-journee-code {\n    width: 40px !important;\n    text-align: center;\n    font-weight: 700;\n    font-size: 16px;\n    text-transform: uppercase;\n    padding: 6px !important;\n}\n\n.type-journee-libelle {\n    flex: 1;\n    min-width: 120px;\n}\n\n.type-journee-preview {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 14px;\n    flex-shrink: 0;\n    border: 1px solid rgba(0,0,0,0.1);\n}\n\n/* ============================================\n   TYPES PREVIEW (résumé)\n   ============================================ */\n.types-preview {\n    margin-top: 12px;\n}\n\n.types-preview h3 {\n    font-size: 0.95rem;\n    margin-bottom: 8px;\n    color: #475569;\n}\n\n.types-preview-grid {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.type-preview-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n}\n\n.type-preview-badge {\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 12px;\n    flex-shrink: 0;\n\tmargin-bottom: 12px;\n}\n\n/* ============================================\n   TYPE JOURNÉE - CELLULE DYNAMIQUE\n   ============================================ */\n.type-journee-cell {\n    font-weight: 700;\n}\n\n.niveau-actions .btn-icon {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n    background: var(--bg);\n    color: var(--secondary);\n    border: 1px solid var(--border);\n}\n\n.niveau-actions .btn-icon:hover:not(:disabled) {\n    background: var(--primary);\n    color: white;\n    border-color: var(--primary);\n}\n\n.niveau-actions .btn-moins {\n    background: #fee2e2;\n    color: var(--danger);\n    border-color: #fecaca;\n}\n\n.niveau-actions .btn-moins:hover:not(:disabled) {\n    background: var(--danger);\n    color: white;\n}\n\n/* ============================================\n   TYPE MÉMORISÉ - INDICATEUR FIXE À GAUCHE\n   ============================================ */\n.memorized-type-indicator {\n    min-width: 170px;\n    max-width: 170px;\n    padding: 3px 12px;\n    border-radius: 12px;\n    font-size: 11px;\n    white-space: nowrap;\n    text-align: center;\n    border: 1px solid;\n    flex-shrink: 0;\n}\n\n/* ============================================\n   CALENDAR STATUS BAR\n   ============================================ */\n.calendar-status-bar {\n    background: var(--card);\n    padding: 5px 15px;\n    border-radius: 8px;\n    margin-bottom: 6px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: nowrap;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n    font-size: 12px;\n}\n\n.calendar-edit-hints {\n    display: flex;\n    gap: 12px;\n    color: #475569;\n    flex-wrap: wrap;\n}\n\n.calendar-edit-hints span {\n    font-size: 11px;\n}\n\n/* ============================================\n   SCROLL HORIZONTAL CALENDRIER\n   ============================================ */\n.calendar-wrapper {\n    overflow-x: auto;\n    overflow-y: visible;\n}\n\n/* ============================================\n   LÉGENDE - RACCOURCI CLAVIER\n   ============================================ */\n.legend-shortcut {\n    color: var(--secondary);\n    font-style: italic;\n    font-size: 12px;\n}\n\n.legend h3 {\n    display: none;\n}\n\n/* `.dashboard-section` et `.dashboard-collapse-btn` RETIREES au lot 5.5 : un\n   seul bouton repliait les DEUX volets a la fois. Ce sont maintenant deux cartes\n   repliables independamment, dont le titre porte le chevron (`.pl-repliable`). */\n\n.type-row-disabled {\n    opacity: 0.6;\n    background: #f8fafc;\n}\n\n/* --- Types légende --- */\n.types-legend {\n    margin-top: 12px;\n    padding: 8px 14px;\n    background: #f0f9ff;\n    border: 1px solid #bae6fd;\n    border-radius: 8px;\n    font-size: 0.78rem;\n    color: #0c4a6e;\n    line-height: 1.5;\n}\n\n.types-legend p {\n    margin: 2px 0;\n}\n\n/* =============================================================================\n   Niveaux 2 — Affichage condensé en ligne\n   ============================================================================= */\n\n/* --- En-tête du tableau groupes --- */\n.groupes-table-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 8px;\n    background: #f1f5f9;\n    border-radius: 6px;\n    margin-bottom: 4px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.gt-h-num { width: 28px; text-align: center; }\n.gt-h-couleur { width: 30px; }\n.gt-h-nom { width: 110px; }\n.gt-h-heures-label { flex: 0 0 auto; margin-left: auto; margin-right: 4px; font-style: italic; }\n\n.gt-h-type {\n    width: 80px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 0.8rem;\n}\n\n.gt-h-type-disabled {\n    text-decoration: line-through;\n    opacity: 0.5;\n}\n\n.gt-num {\n    width: 28px;\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #94a3b8;\n}\n\n.gt-couleur { width: 30px; }\n\n.gt-nom {\n    width: 110px;\n    padding: 4px 6px;\n    border: 1px solid #cbd5e1;\n    border-radius: 4px;\n    font-size: 0.85rem;\n}\n\n.gt-nom-single {\n    border: none;\n    font-weight: 600;\n    color: #334155;\n    background: transparent;\n    padding: 4px 6px;\n}\n\n.gt-heures-sep {\n    flex: 0 0 auto;\n    margin-left: auto;\n}\n\n/* --- Cellule heures par type --- */\n.gt-heures-cell {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    width: 80px;\n    justify-content: center;\n}\n\n.gt-heures-disabled {\n    opacity: 0.4;\n}\n\n.gt-type-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: 3px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.gt-heures-input {\n    width: 54px;\n    padding: 3px 4px;\n    border: 1px solid #cbd5e1;\n    border-radius: 4px;\n    text-align: right;\n    font-size: 0.85rem;\n    font-weight: 600;\n    font-family: 'Courier New', monospace;\n}\n\n.gt-heures-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.gt-heures-unit {\n    font-size: 0.75rem;\n    color: #64748b;\n}\n\n.gt-heures-grise {\n    font-size: 0.75rem;\n    color: #cbd5e1;\n    font-style: italic;\n    letter-spacing: 1px;\n}\n\n/* --- Résumé : info contrôle --- */\n.type-preview-info {\n    font-size: 0.72rem;\n    color: #64748b;\n    font-style: italic;\n    margin-left: 2px;\n}\n\n/* =============================================================================\n   DASHBOARD — Couverture heures\n   ============================================================================= */\n\n.couverture-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.couverture-section {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 10px 12px;\n}\n\n.couverture-section-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.couverture-type-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.couverture-type-label {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: #334155;\n}\n\n.couverture-no-data {\n    font-size: 0.78rem;\n    color: #94a3b8;\n    font-style: italic;\n    padding: 4px 0;\n}\n\n.couverture-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.couverture-item {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.couverture-item-none {\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n    opacity: 0.5;\n}\n\n.couverture-item-top {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.78rem;\n}\n\n.couverture-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.couverture-label {\n    font-weight: 600;\n    color: #334155;\n    font-size: 0.78rem;\n    min-width: 70px;\n}\n\n.couverture-heures {\n    color: #64748b;\n    font-size: 0.72rem;\n    margin-left: auto;\n    white-space: nowrap;\n}\n\n.couverture-na {\n    font-size: 0.72rem;\n    color: #94a3b8;\n    font-style: italic;\n}\n\n.couverture-bar-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-left: 14px;\n}\n\n.couverture-bar-bg {\n    flex: 1;\n    height: 10px;\n    background: #e2e8f0;\n    border-radius: 5px;\n    position: relative;\n    overflow: hidden;\n    min-width: 80px;\n}\n\n.couverture-bar-fill {\n    height: 100%;\n    border-radius: 5px;\n    transition: width 0.4s ease;\n}\n\n.couverture-bar-over {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    border-radius: 0 5px 5px 0;\n}\n\n.couverture-pct {\n    font-size: 0.78rem;\n    font-weight: 700;\n    min-width: 38px;\n    text-align: right;\n}\n\n.couverture-icone {\n    font-size: 0.75rem;\n    flex-shrink: 0;\n}\n\n/* =============================================================================\n   DASHBOARD — Indicateurs tableau\n   ============================================================================= */\n\n.indicateurs-table th {\n    font-size: 0.7rem !important;\n    padding: 4px 6px !important;\n    white-space: nowrap;\n}\n\n.indicateurs-table td {\n    padding: 4px 6px !important;\n    font-size: 0.78rem;\n}\n\n.indicateurs-table td:first-child {\n    display: table-cell !important;\n    text-align: center !important;\n}\n\n.indicateur-type-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    font-size: 0.68rem;\n    font-weight: 700;\n}\n\n.indicateur-val {\n    text-align: right !important;\n    font-family: 'Courier New', monospace;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.indicateur-icone {\n    text-align: center !important;\n    font-size: 0.75rem;\n}\n\n.indicateur-pct {\n    text-align: right !important;\n    font-weight: 700;\n    font-size: 0.82rem !important;\n    white-space: nowrap;\n}\n\n/* =============================================================================\n   MATRICE VISIBILITÉ PAR MOIS — dans filter-panel\n   ============================================================================= */\n\n.mois-detail-toggle {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 10px;\n    padding: 6px 12px;\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--primary);\n    transition: all 0.2s;\n    width: 100%;\n    text-align: left;\n}\n\n.mois-detail-toggle:hover {\n    background: #dbeafe;\n    border-color: var(--primary);\n}\n\n.mois-matrix-section {\n    margin-top: 8px;\n    animation: fadeIn 0.2s ease;\n}\n\n.mois-matrix-wrapper {\n    overflow-x: auto;\n    border: 1px solid var(--border);\n    border-radius: 6px;\n}\n\n.mois-matrix {\n    border-collapse: collapse;\n    font-size: 10px;\n    width: 100%;\n}\n\n.mois-matrix th,\n.mois-matrix td {\n    padding: 0;\n    text-align: center;\n    border: 1px solid var(--border);\n}\n\n.mois-matrix-corner {\n    background: var(--bg);\n    min-width: 70px;\n    width: 70px;\n}\n\n.mois-matrix-mois-header {\n    background: var(--primary);\n    color: white;\n    font-weight: 700;\n    font-size: 9px;\n    padding: 4px 2px !important;\n    min-width: 32px;\n    letter-spacing: 0.5px;\n}\n\n.mois-matrix-label {\n    text-align: left !important;\n    background: var(--bg);\n    padding: 3px 6px !important;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.mois-matrix-dot {\n    display: inline-block;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    margin-right: 4px;\n    vertical-align: middle;\n}\n\n.mois-matrix-label-text {\n    font-size: 9px;\n    vertical-align: middle;\n    color: #334155;\n}\n\n/* Cellules cliquables */\n.mois-matrix-cell {\n    cursor: pointer;\n    width: 32px;\n    height: 24px;\n    transition: all 0.15s;\n    user-select: none;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.mois-cell-visible {\n    color: white;\n    text-shadow: 0 1px 1px rgba(0,0,0,0.3);\n}\n\n.mois-cell-visible:hover {\n    opacity: 0.7;\n}\n\n.mois-cell-hidden {\n    background: repeating-linear-gradient(\n        45deg,\n        #f1f5f9,\n        #f1f5f9 3px,\n        #e2e8f0 3px,\n        #e2e8f0 6px\n    ) !important;\n    color: transparent;\n}\n\n.mois-cell-hidden:hover {\n    background: #dbeafe !important;\n    color: var(--primary) !important;\n}\n\n.mois-matrix-actions {\n    display: flex;\n    gap: 6px;\n    margin-top: 6px;\n    justify-content: flex-end;\n}\n\n.btn-students.btn-disabled,\n.btn-students:disabled {\n    background: #e2e8f0;\n    color: #94a3b8;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.groupes-semestres-header {\n    display: grid;\n    grid-template-columns: 40px 40px 1fr 60px 70px 70px 60px 70px 70px 80px;\n    gap: 4px;\n    padding: 10px 12px;\n    background: #f1f5f9;\n    border-bottom: 2px solid #e5e7eb;\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: #475569;\n    align-items: center;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .groupes-semestres-header,\n    .groupe-row-semestres {\n        grid-template-columns: 30px 30px 80px 8px 55px 55px 8px 55px 55px 60px;\n        font-size: 0.75rem;\n    }\n    \n    .gs-heures-input {\n        width: 50px;\n        padding: 4px;\n    }\n}\n\n/* ============================================\n   SETUP WIZARD - BARRE DE PROGRESSION\n   ============================================ */\n.progress-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n}\n\n.progress-modal {\n    background: white;\n    border-radius: 12px;\n    padding: 30px 40px;\n    min-width: 350px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    text-align: center;\n}\n\n.progress-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 20px;\n}\n\n.progress-bar-container {\n    background: #e2e8f0;\n    border-radius: 10px;\n    height: 20px;\n    overflow: hidden;\n    margin-bottom: 15px;\n}\n\n.progress-bar {\n    height: 100%;\n    background: linear-gradient(90deg, #3b82f6 0%, #22c55e 100%);\n    border-radius: 10px;\n    transition: width 0.3s ease;\n}\n\n.progress-message {\n    font-size: 14px;\n    color: #64748b;\n    margin-bottom: 8px;\n}\n\n.progress-percent {\n    font-size: 24px;\n    font-weight: 700;\n    color: #3b82f6;\n}\n\n.btn-students:hover:not(:disabled):not(.btn-disabled) {\n    background: #dbeafe;\n    border-color: #3b82f6;\n    color: #1e40af;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);\n}\n\n.btn-students.btn-disabled,\n.btn-students:disabled {\n    background: #f8fafc;\n    color: #cbd5e1;\n    border-color: #e2e8f0;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n/* PlanningApp - sticky-top */\n.sticky-top {\n    position: sticky;\n    top: 8px;\n    z-index: 1000;\n    margin: 8px 12px 0 12px;\n    border-radius: 12px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n    background: white;\n}\n\n/* PlanningApp - sticky-top */\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    margin: 0;\n    border-radius: 0 0 12px 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n    background: white;\n}\n\n/* Container principal */\n.calendar-wrapper {\n    overflow-x: auto;\n    overflow-y: visible;\n    width: 100%;\n}\n\n/* Grille des mois - flexbox qui ne wrap pas */\n.calendar-grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    gap: 8px;\n    width: max-content; /* Important : permet à la grille de dépasser */\n}\n\n/* Chaque colonne de mois - largeur automatique */\n.month-column {\n    flex-shrink: 0;        /* Ne pas rétrécir */\n    flex-grow: 0;          /* Ne pas grandir */\n    width: auto;           /* Largeur automatique basée sur le contenu */\n    min-width: min-content; /* Au minimum la largeur du contenu */\n}\n\n/* Headers des colonnes */\n.column-headers {\n    display: grid;\n    /* gridTemplateColumns est défini en inline */\n    gap: 1px;\n}\n\n/* Grille des jours */\n.days-grid {\n    display: grid;\n    /* gridTemplateColumns est défini en inline */\n    gap: 1px;\n}\n\n/* Header du mois - s'adapte à la largeur */\n.month-header {\n\tbackground: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n    color: white; padding: 8px; text-align: center; font-weight: 700; font-size: 12px;\n    text-align: center;\n    font-weight: bold;\n    padding: 8px 4px;\n    border-radius: 4px 4px 0 0;\n    white-space: nowrap;\n}\n\n/* Cellules */\n.day-cell {\n    min-width: 0; /* Permet le rétrécissement si nécessaire */\n    box-sizing: border-box;\n}\n\n.col-header {\n    min-width: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
